import CheckoutNavBar from './CheckoutNavBar';
import OrderMethodsTabBar from './OrderMethodsTabBar';

export default {
  CheckoutNavBar,
  OrderMethodsTabBar,
};
